import { Flex, ProgressCircle } from '@adobe/react-spectrum';

export function Loader() {
  return (
    <Flex width="100%" justifyContent="center" marginTop={10}>
      <ProgressCircle aria-label="Loading…" isIndeterminate />
    </Flex>
  );
}
